import consumer from "./consumer"

const crawlData = document.getElementById("crawl-data")
if (crawlData) {
  const crawlId = crawlData.dataset.crawlId
  if (crawlId) {
    consumer.subscriptions.create(
      { channel: "CrawlChannel", crawl_id: crawlId },
      {
        connected() {
          // Called when the subscription is ready for use on the server
        },
        disconnected() {
          // Called when the subscription has been terminated by the server
        },
        received(data) {
          // Called when there's incoming data on the websocket for this channel
        },
      }
    )
  } else {
    console.warn("CrawlChannel: No crawl_id found in #crawl-data element.")
  }
} else {
  console.warn("CrawlChannel: #crawl-data element not found on page.")
}
